import { drupal } from "@/lib/drupal/drupal"
import { DrupalNode, DrupalTaxonomyTermProduct } from "@/types"
import { ProductNavigationClient } from "./ProductNavigation.client"

export const ProductNavigation = async({resource}: {
  resource: DrupalNode
}) => {
  const product:DrupalTaxonomyTermProduct = resource.field_product ?? resource.field_products[0]

  if (!product.field_flag_product_navigation) {
    return <></>
  }
  
  const {tree: menu_links} = await drupal.getMenu(product.field_menu.resourceIdObjMeta.drupal_internal__target_id)
  return <ProductNavigationClient menu_links={menu_links} product={product} />
}

export const ProductNavigationLoading = () => {
  return <nav className="sticky top-0 bg-white data-[sticky=true]:shadow-lg group z-10 animate-pulse">
    <div className="container mx-auto flex gap-x-6 items-center px-5 py-3 text-navy-600 font-medium text-lg group-data-[sticky=true]:py-0">
      <h2 className="bg-gray-400 rounded-lg">&nbsp;</h2>
      <ul className="flex gap-x-6 items-center" role="menu" aria-orientation="horizontal">
           <li role="menuitem" className="w-64 bg-gray-400 rounded-lg">&nbsp;</li>
           <li role="menuitem" className="w-64 bg-gray-400 rounded-lg">&nbsp;</li>
           <li role="menuitem" className="w-64 bg-gray-400 rounded-lg">&nbsp;</li>
           <li role="menuitem" className="w-64 bg-gray-400 rounded-lg">&nbsp;</li>
      </ul>
    </div>
  </nav>
}